import { render } from "./AdicionarProfissionalClinica.vue?vue&type=template&id=2d235491&scoped=true"
import script from "./AdicionarProfissionalClinica.vue?vue&type=script&lang=js"
export * from "./AdicionarProfissionalClinica.vue?vue&type=script&lang=js"

import "./AdicionarProfissionalClinica.vue?vue&type=style&index=0&id=2d235491&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d235491"]])

export default __exports__